module.exports = __webpack_public_path__ + "static/media/18.050a2387.jpg";